// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"e987f242","394":"d24634ae","506":"d24634ae","532":"995e5674","613":"3f00f4a4","863":"995e5674"}[chunkId] + ".chunk.css";
};